import { getRelativePosition } from '@/lego/utils/dom/element';

var offset;
var body;
var fieldErrors = [];

const fieldsHandler = () => {
  for (const fieldName in fieldErrors) {
    if (fieldErrors[fieldName]) {
      const field = document.getElementById(fieldName);
      const y = getRelativePosition(field).top - offset;

      body.scrollTo({ top: y, behavior: 'smooth' });
      break;
    }
  }
};

const handleError = field => {
  fieldErrors[field.name] = field.hasErrors;
};

export default {
  inserted(el, binding, vnode) {
    offset = binding.value.offset;
    body = document.querySelector(binding.value.body);

    const fieldNames = Object.keys(binding.value.data);
    var form = vnode.componentInstance;
    var fields = form.$children;

    fields = fields.filter(field => fieldNames.includes(field.name));

    fields.forEach(field => {
      field.$on('validation', handleError);
    });

    form.$on('failed-validation', fieldsHandler);
  },
};
